import { normalizeSearch } from "@partners/ui";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Search-param schema for the "Your Sub IBs" page (one of IB network's two
 * sub-nav destinations, alongside "Your Master IB" — `../your-master-ib`):
 *
 * - `tab=<TAB_REBATE_PROGRAMS | TAB_SUB_IBS>` selects which of the page's two
 *   tabs is active (`SubIBReportPage`'s `initialTab`/`onTabChange` — the
 *   portal writes this back via `navigate()` on every tab switch, since
 *   `packages/ui` stays router-agnostic). Both values must come before the
 *   `#` in a URL — a query param can never follow a fragment.
 * - `rebate_program=<HOID>` deep-links into a specific program: seeds the
 *   Shared Rebate Programs tab's search box and auto-opens its detail
 *   drawer once it loads (`SharedRebateProgramsView`'s
 *   `initialProgramSearch`).
 *
 * `validateSearch` cannot live in `your-sub-ibs.lazy.tsx` (a
 * `createLazyFileRoute` module) so this non-lazy sibling carries it,
 * mirroring the `performance.tsx` + `performance.lazy.tsx` split (PART-4034).
 *
 * TODO: the Sub IBs tab (`SubIBsTable`, currently hidden behind the
 * `masterSubIbPhase2` flag) has no per-row deep-link support yet — add its
 * own param here (e.g. `sub_ib=<id>`) and an equivalent initial-seed/
 * auto-open prop on its view once that tab ships.
 */
export const Route = createFileRoute(
  "/_authenticated/_IBComplete/ib-network/your-sub-ibs",
)({
  validateSearch: (
    search: Record<string, unknown>,
  ): { rebate_program?: string; tab?: string } =>
    normalizeSearch(search, [], ["rebate_program", "tab"]),
});
